import { render, staticRenderFns } from "./HeaderSearch.vue?vue&type=template&id=97a0d568&scoped=true"
import script from "./HeaderSearch.vue?vue&type=script&lang=js"
export * from "./HeaderSearch.vue?vue&type=script&lang=js"
import style0 from "./HeaderSearch.vue?vue&type=style&index=0&id=97a0d568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a0d568",
  null
  
)

export default component.exports